import Mtr from './Mtr'
import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'mtr',
    name: 'mtr',
    component: Mtr,
    beforeEnter: ifAuthenticated,
    props: true
  },
  ...require('./mtrComponentGroup/routes').routes
]
